import i18n from '@/plugins/i18n';
// import { NAVTABS } from '@/utils/templates/smTemplate/sm.constants.ts';

export const getSMNavTabs = () => [
  //New Layout
  // {
  //   name: NAVTABS.SM_APPLICATIONS_TAB,
  //   path: 'smApplication',
  //   fullPath: '/sm/smApplication',
  //   appTabs: [
  //     {
  //       tabName: NAVTABS.SM_DASHBOARD_TAB,
  //       routerName: 'smDashboard'
  //     },
  //     {
  //       tabName: NAVTABS.SM_KPM_TAB,
  //       routerName: 'smKPM'
  //     },
  //     {
  //       tabName: NAVTABS.SM_ERRORS_TAB,
  //       routerName: 'smErrors'
  //     }
  //     // {
  //     //   tabName: NAVTABS.SM_REPORTS_TAB,
  //     //   routerName: 'smReports'
  //     // }
  //   ]
  // },
  {
    name: i18n.global.t('sm.endpoints'),
    path: 'smEndpoints',
    fullPath: '/sm/smEndpoints',
    appTabs: [
      {
        tabName: i18n.global.t('applications'),
        routerName: 'smAvailability',
        fullPath: '/sm/smEndpoints/smAvailability',
        availabilityTabs: [
          {
            tabName: i18n.global.t('sm.all-groups'),
            routerName: 'allGroups',
          },
          {
            tabName: i18n.global.t('sm.all-endpoints'),
            routerName: 'allEndpoints',
          },
          {
            tabName: i18n.global.t('sm.mapped-endpoints'),
            routerName: 'mappedEndpoints',
          },
        ],
      },
      // {
      //   tabName: NAVTABS.SM_PERFORMANCE_TAB,
      //   routerName: 'smPerformance'
      // }
    ],
  },
  {
    name: i18n.global.t('sm.secret-manager'),
    path: 'smSecretManager',
    fullPath: '/sm/smSecretManager',
    isPlatformAdminAccess: true,
    resourceGroup: 'settings', // To support RBACV2 platform permissions
  },
  {
    name: i18n.global.t('sm.token-manager'),
    path: 'smTokenManager',
    fullPath: '/sm/smTokenManager',
    isPlatformAdminAccess: true,
    resourceGroup: 'settings',
  },

  //Old Layout
  // {
  //   name: NAVTABS.SM_DASHBOARD_TAB,
  //   path: 'smDashboard',
  //   fullPath: '/sm/smDashboard'
  // },
  // {
  //   name: NAVTABS.SM_APPLICATION_TAB,
  //   path: 'smApplication',
  //   fullPath: '/sm/smApplication'
  // },
  // {
  //   name: NAVTABS.SM_KPM_TAB,
  //   path: 'smKPM',
  //   fullPath: '/sm/smKPM'
  // },
  // {
  //   name: NAVTABS.SM_ERRORS_TAB,
  //   path: 'smErrors',
  //   fullPath: '/sm/smErrors'
  // }
];

const synthetic = {
  key: 'sm',
  name: i18n.global.t('syntheticMonitoring'),
  icon: 'sm',
  navTabs: getSMNavTabs(),
};
export default synthetic;
